import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const VARIANT_CLASS = {
    solid: 'sec-badge--solid',
    soft: 'sec-badge--soft',
    coral: 'sec-badge--coral',
    dot: 'sec-badge--dot',
};
/** Kleines Status-/Zaehler-Label (z. B. ungelesene Benachrichtigungen). */
export const Badge = forwardRef(function Badge({ variant = 'soft', className, ...rest }, ref) {
    return _jsx("span", { ref: ref, className: cn('sec-badge', VARIANT_CLASS[variant], className), ...rest });
});
